import { Callback } from "../sharedState/SharedState";
import { addToCart } from "./add-to-cart";
import { removeFromCart } from "./remove-from-cart";

export const globalCallbacks: { [key: string]: Callback } = {
    "add-to-cart": addToCart,
    "remove-from-cart": removeFromCart,
};